import { deviceFormApi } from "../../api/deviceFormApi"

import { deviceFormsSignal, deviceFormsLoadedSignal, deviceFormsErrorSignal } from "../signals/deviceFormSignals"

import { NotificationTypes, addNotification } from "./notificationActions.js"

import { uploadFileToPresignedURL, saveFile } from "../../utils/file.js"

export async function fetchDeviceForms(businessEntityId, filters, config, accessToken) {
    deviceFormsLoadedSignal.value = false
    deviceFormsSignal.value = []
    return await deviceFormApi.fetchDeviceForms(businessEntityId, filters, config, accessToken).then(
        (result) => {
            deviceFormsSignal.value = result
            deviceFormsErrorSignal.value = null
            deviceFormsLoadedSignal.value = true
            return result
        }
    ).catch(
        (err) => {
            deviceFormsErrorSignal.value = err.message
            addNotification("Failed to fetch forms: ".concat(err.message), NotificationTypes.ERROR, true)
        }
    )
}

export const updateDeviceFormUploadStatus = async function (businessEntityId, formId, config, accessToken) {
    return await deviceFormApi.updateDeviceFormUploadStatus(businessEntityId, formId, config, accessToken)
}

export const createDeviceForm = async function (businessEntityId, form, file, config, accessToken) {
    const f = "createDeviceForm"
    const print = true
    deviceFormsLoadedSignal.value = false
    return await deviceFormApi.createDeviceForm(businessEntityId, form, config, accessToken).then(
        async (parsed) => {
            if (print) {
                console.log(f.concat(": About to log response"))
                console.log(parsed)
                console.log(f.concat(": Logged response"))
            }
            const presignedUrl = parsed.presignedURL.url
            const formId = parsed.presignedURL.id
            if (print) {
                console.log("The uploaded form was assigned ID ".concat(formId))
            }
            return await uploadFileToPresignedURL(file, presignedUrl).then(
                async () => {
                    if (print) {
                        console.log(f.concat(": inside the post-file upload success callback for marking form as uploaded"))
                    }
                    return await updateDeviceFormUploadStatus(businessEntityId, formId, config, accessToken).then(
                        async () => {
                            addNotification(`Device form uploaded successfully.`, NotificationTypes.SUCCESS, true)
                            return await fetchDeviceForms(businessEntityId, null, config, accessToken).then(
                                () => {
                                    return parsed
                                }
                            )
                        }
                    ).catch(
                        (error) => {
                            addNotification("Failed to update form upload status: ".concat(error.toString()), NotificationTypes.ERROR, true)
                            throw error
                        }
                    )
                }
            ).catch(
                async (error1) => {
                    if (print) {
                        console.error(f.concat(": file upload failed"))
                    }
                    return await updateDeviceFormUploadStatus(businessEntityId, formId, config, accessToken).then(
                        () => {
                            addNotification("Marked form upload as failed: ".concat(error1.toString()), NotificationTypes.ERROR, true)
                            throw error1
                        }
                    ).catch(
                        (error2) => {
                            addNotification(
                                "Failed to update form upload status: \n".concat(error1.toString()).concat("\n").concat(error2.toString()), NotificationTypes.ERROR, true)
                            throw error2
                        }
                    )
                }
            )
        }
    ).catch(
        (error) => {
            addNotification("Form API error: ".concat(error.toString()), NotificationTypes.ERROR, true)
            throw error
        }
    )
}

export const downloadDeviceForm = async function (businessEntityId, record, config, accessToken) {
    if (!businessEntityId) {
        throw new Error("Business entity ID is undefined")
    }
    if (!record) {
        throw new Error("Record is undefined")
    }
    if (!config) {
        throw new Error("config is undefined")
    }
    if (!accessToken) {
        throw new Error("Access token is undefined")
    }
    let filename = record.name
    let fileLocation = record.fileLocation
    let fileExtension = fileLocation.key.split('.')[1]
    return await deviceFormApi.downloadDeviceForm(businessEntityId, record.id, fileExtension, config, accessToken).then(async (response) => {
        let content = new Uint8Array()
        for await (const chunk of response.body) {
            let temp = new Uint8Array(content.length + chunk.length)
            temp.set(content)
            temp.set(chunk, content.length)
            content = temp
        }
        let saveFileNameAs
        if (filename.indexOf('.tgz') == -1) {
            saveFileNameAs = filename.concat('.tgz')
        }
        else {
            saveFileNameAs = filename;
        }
        saveFile(content, saveFileNameAs, 'application/x-gzip')
        addNotification("Successfully downloaded file ".concat(saveFileNameAs), NotificationTypes.SUCCESS, true, "Download successful")
        return true
    })
}

export const deleteDeviceForm = async function (businessEntityId, record, config, accessToken) {
    deviceFormsLoadedSignal.value = false
    return await deviceFormApi.deleteDeviceForm(businessEntityId, record.id, config, accessToken).then(
        async (result) => {
            return await fetchDeviceForms(businessEntityId, null, config, accessToken).then(
                () => {
                    return result
                }
            )
        }
    ).catch(
        (error) => {
            deviceFormsErrorSignal.value = error
            throw error
        }
    )
}